import { Props_SnippetContentColumn } from './ContentColumn.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SnippetLink from '../Shared/Link/Link'

const SnippetContentColumn = (props: Props_SnippetContentColumn) => {
    const { heading, repeatable_entry } = props
    const classHeadingVisibility: string = heading.visibility.value ? `snippet-content-column__heading--${heading.visibility.value}` : ''

    return (
    <section className="snippet-content-column">
        <div className={`snippet-content-column__container`}>
            <h2 className={`snippet-content-column__heading ${classHeadingVisibility}`}>{heading?.content?.value}</h2>
            <div className="snippet-content-column__container-entries">
            { repeatable_entry.map((entry, index: number) => (
                <div key={index} className={`snippet-content-column__entry`}>
                    { entry.image?.value && (
                        <figure className="snippet-content-column__entry-image-container">
                            <img
                                className="snippet-content-column__entry-image"
                                loading="lazy"
                                height={190}
                                width={350}
                                src={entry.image.value}
                                alt={entry.alt?.value ? entry.alt.value : ''}
                            />
                        </figure>
                    )}
                    <div className="snippet-content-column__entry-content-container">
                        { entry.heading?.value && (
                            <>
                                <h3 className="snippet-content-column__entry-title">{ entry.heading?.value }</h3>
                                <hr className="snippet-content-column__entry-divider" />
                            </>
                        )}
                        { entry.content?.value && <div className="snippet-content-column__entry-content">{ CompileMarkdown(entry.content.value) }</div> }
                        <SnippetLink
                            linkStyles={entry.linkStyle?.value}
                            className="snippet-content-column__entry-link"
                            url={entry.linkHref?.value}
                            target={entry.linkTarget?.value}
                        >
                            {entry.linkContent?.value}
                        </SnippetLink>
                    </div>
                </div>
            ))}
            </div>
        </div>
    </section>
    )
}

export default SnippetContentColumn